import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { clearBillingHistory, getBillingHistory } from 'redux/modules/billing';
import { Spinner, PageHeader, EmptyState } from 'components';
import { LeftNavLayout } from 'containers';
import * as styles from './BillingHistoryTable.scss';
var BillingHistoryTable = (_dec = connect(function (state, ownProps) {
  return {
    config: state.config,
    billingHistory: state.billing.billingHistoryByOrgId && state.billing.billingHistoryByOrgId[ownProps.orgId] ? state.billing.billingHistoryByOrgId[ownProps.orgId] : [],
    loadingBillingHistory: state.billing.loadingBillingHistory,
    organization: state.organization.current
  };
}, {
  clearBillingHistory: clearBillingHistory,
  getBillingHistory: getBillingHistory
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(BillingHistoryTable, _Component);

  var _super = _createSuper(BillingHistoryTable);

  function BillingHistoryTable() {
    var _this;

    _classCallCheck(this, BillingHistoryTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleDownload", function (invoiceId) {
      window.open("/api/billing/org/".concat(_this.props.orgId, "/invoice/").concat(invoiceId, "/download"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderRow", function (rowData, index) {
      var iconType = function () {
        if (rowData.amountRefunded) {
          return "ion-ios-refresh ".concat(styles.refunded);
        }

        if (rowData.paid) {
          return "ion-checkmark-circled ".concat(styles.approved);
        }

        return "ion-close-circled ".concat(styles.failed);
      }();

      return /*#__PURE__*/React.createElement("div", {
        className: styles.row,
        key: index
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.col0
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.approvalIcon, " icon ").concat(iconType)
      })), /*#__PURE__*/React.createElement("span", {
        className: styles.col1
      }, rowData.createdDate), rowData.oneTimeCharge ? /*#__PURE__*/React.createElement("span", {
        className: styles.col2
      }, 'One Time Charge') : /*#__PURE__*/React.createElement("span", {
        className: styles.col2
      }, rowData.description ? rowData.description : "Invoice from ".concat(rowData.invoiceStartDate, " - ").concat(rowData.invoiceEndDate)), /*#__PURE__*/React.createElement("span", {
        className: styles.col3
      }, rowData.amount), /*#__PURE__*/React.createElement("span", {
        className: styles.col4
      }, rowData.cardBrand && rowData.last4 ? "".concat(rowData.cardBrand, " ending in ").concat(rowData.last4) : rowData.stripeId ? 'None' : ''), /*#__PURE__*/React.createElement("span", {
        className: styles.col5
      }, rowData.stripeId && /*#__PURE__*/React.createElement("span", {
        className: styles.link,
        onClick: function onClick() {
          _this.props.handleView(rowData);
        }
      }, "View")), /*#__PURE__*/React.createElement("span", {
        className: styles.col6
      }, !rowData.oneTimeCharge && rowData.stripeId && /*#__PURE__*/React.createElement("span", {
        className: styles.link,
        onClick: function onClick() {
          return _this.handleDownload(rowData.stripeId);
        }
      }, "Download")));
    });

    return _this;
  }

  _createClass(BillingHistoryTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getBillingHistory(this.props.orgId);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearBillingHistory();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.orgId !== this.props.orgId) {
        this.props.getBillingHistory(this.props.orgId);
      }
    }
    /** *********************************************************
     EVENT HANDLERS
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var tableRows = this.props.billingHistory ? this.props.billingHistory.map(function (rowData, index) {
        return _this2.renderRow(rowData, index);
      }) : null;

      if (this.props.loadingBillingHistory && !this.props.billingHistory) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            position: 'relative',
            height: 75
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      } else if (!this.props.loadingBillingHistory && this.props.billingHistory.length === 0) {
        return /*#__PURE__*/React.createElement(EmptyState, {
          text: "You do not have any Billing History",
          iconName: "fa fa-history",
          iconSize: "95px",
          style: {
            marginTop: 24
          }
        });
      }

      if (this.props.isScheinClient) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, "Billing History is unavailable for Henry Schein clients.");
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.col0
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.col1
      }, "Date"), /*#__PURE__*/React.createElement("span", {
        className: styles.col2
      }, "Description"), /*#__PURE__*/React.createElement("span", {
        className: styles.col3
      }, "Amount"), /*#__PURE__*/React.createElement("span", {
        className: styles.col4
      }, "Payment Method"), /*#__PURE__*/React.createElement("span", {
        className: styles.col5
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.col6
      })), tableRows, !this.props.billingHistory.length && this.props.loadingBillingHistory && /*#__PURE__*/React.createElement("div", {
        style: {
          height: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return BillingHistoryTable;
}(Component), _defineProperty(_class2, "defaultProps", {
  handleView: function handleView() {
    console.log('default view invoice');
  }
}), _temp)) || _class);
export { BillingHistoryTable as default };